import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateCountry } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateCountry() {
  return useMutation({
    mutationFn: async ({ item, countryId }) => {
      const payload = buildPayload(item);
      const response = await updateCountry({ item: payload, countryId });
      return response;
    },
    onSuccess: () => {
      toast.success("Country Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
